module.exports = __webpack_public_path__ + "6e1e816ccfe68ed0ec95a59c20955caf.pdf";